import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles<Theme>(theme => ({
  row: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(2),

    '&:last-child': {
      marginBottom: 0,
    },
  },
  contractTypeLabel: {
    width: 160,
    flexShrink: 0,
    color: theme.palette.common.gray800,
  },
  select: {
    flex: 1,
  },
  errorsAlert: {
    marginBottom: theme.spacing(3),
    '& > div': {
      margin: 'initial',
    },
  },
  noTemplatesLink: {
    color: theme.palette.common.blue400,
  },
}));
